export default "__VITE_ASSET__92a10b4b__"